module.exports = __webpack_public_path__ + "files/1eac23416f1697416da6bded9c98814a.eot";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/pt_sans-web-bold-webfont.eot
 ** module id = 423
 ** module chunks = 0
 **/